import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { parseParams } from 'helper/utility'
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from 'Redux/axiosHelper'
import { BlogPayloadType } from 'types/blogs/blogs'
import axios from 'axios'
import { BASE_URL, failureMessage } from 'api/global'

export const createBlogs = async (payload: BlogPayloadType) => {
  const res = await axiosPost(payload, `v1/blogs`)
  return res.data
}

export const useCreateBlog = () => {
  const queryClient = useQueryClient()
  return useMutation(createBlogs, {
    onSuccess: (newBlog) => {
      queryClient.setQueryData(
        ['Create-blogs'],
        (oldData: any[] | undefined) => {
          if (!oldData) return [newBlog]
          return [newBlog, ...oldData]
        }
      )
    },
  })
}


export const getBlogs = async (params : any) => {
  const parsedParams = parseParams(params)
  const res = await axiosGet(`v1/blogs?${parsedParams}`)
  return res.data
}



export const deleteBlog = async (blogId: string) => {
  const res = await axiosDelete(`v1/blogs/${blogId}`)
  return res.data
}
export const useDeleteBlog = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteBlog,
    onSuccess: (_, deletedId) => {
      queryClient.setQueryData(['delete-blogs'], (oldData: any) => {
        if (!oldData?.records) return oldData

        return {
          ...oldData,
          records: oldData.records.filter(
            (blog: any) => blog._id !== deletedId
          ),
        }
      })
    },
  })
}

export const getFilters = async () => {
  const res = await axiosGet(`v1/blogs/filters`)
  return res.data
}

//get Details of blog
export const getBlogDetailsById = async (blogId: string) => {
  const res = await axiosGet(`v1/blogs/${blogId}`)
  return res.data
}

//update blog
export const updateBlog = async (blogId: string, payload: BlogPayloadType) => {
  const res = await axiosPatch(payload, `v1/blogs/${blogId}`)
  return res.data
}

export const useUpdateBlog = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ blogId, payload }: { blogId: string; payload: BlogPayloadType }) =>
    updateBlog(blogId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries(['all-blogs'])
    },
  })
}

export const importBlogFile = async (payload: any[]) => {
  try {
    const response = await axios.post(`${BASE_URL}v1/imports/blogs`, payload)
    if (response.status === 200) {
      return response.data
    } else {
      failureMessage(response?.data?.message || 'An error occurred')
      return Promise.reject(response.data)
    }
  } catch (error: any) {
    failureMessage(error?.response?.data?.message || 'An error occurred')
  }
}

export const confirmBlogImport = async (payload: { validationId: string; confirm: boolean }) => {
  try {
    const response = await axios.put(`${BASE_URL}v1/imports/blogs`, payload)
    if (response.status === 200) {
      return response.data
    } else {
      failureMessage(response?.data?.message || 'An error occurred')
      return Promise.reject(response.data)
    }
  } catch (error: any) {
    failureMessage(error?.response?.data?.message || 'An error occurred')
  }
}

export const exportBlogsData = async (params?: any) => {
  const parsedParams = params ? parseParams(params) : ''
  const res = await axiosGet(`v1/blogs/export${parsedParams ? '?' + parsedParams : ''}`)
  return res.data
}
